import { useDispatch, useSelector } from 'react-redux';
import { Navigate, createSearchParams, useNavigate } from 'react-router-dom';
import { loginPostAsync, logout } from '../slices/loginSlice';

const useCustomLogin = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const exceptionHandler = async (response) => {
    // console.log('Exception------------------------');
    // console.log(response);

    const errorMsg = response.data?.error || response?.error;

    const errorStr = createSearchParams({ error: errorMsg }).toString();
    // console.log(errorStr);

    if (errorMsg === 'REQUIRE_LOGIN') {
      alert('로그인 해야만 합니다.');
      await navigate('/member/login');
      return false;
    }

    if (errorMsg === 'ERROR_ACCESS_TOKEN') {
      alert('로그인이 필요 합니다.');
      await doLogout();
      return false;
    }

    if (errorMsg === 'INVALID_REFRESH_TOKEN') {
      alert('로그인이 필요 합니다.');
      await doLogout();
      return false;
    }

    if (errorMsg === 'Expired') {
      alert('로그인이 필요 합니다.');
      await doLogout();
      return false;
    }

    if (errorMsg === 'ERROR_ACCESSDENIED') {
      alert('해당 메뉴를 사용할 수 있는 권한이 없습니다.');
      await navigate({ pathname: '/member/login', search: errorStr });
      return false;
    }
    return true;
  };

  const loginState = useSelector((state) => state.loginSlice); //-------로그인 상태

  const isLogin = loginState.id ? true : false; //----------로그인 여부

  const isCookieChecked = async () => {
    if (!isLogin) {
      alert('로그인이 필요합니다.');
      await moveToLogin(); // 로그인 페이지로 이동
      return false; // 로그인하지 않은 경우, 이후 로직 실행 차단
    }
    return true;
  };

  const doLogin = async (loginParam) => {
    //----------로그인 함수

    const action = await dispatch(loginPostAsync(loginParam));

    return action.payload;
  };

  const doLogout = () => {
    //---------------로그아웃 함수

    dispatch(logout());

    moveToLogin();
  };

  const moveToPath = (path) => {
    //----------------페이지 이동
    navigate({ pathname: path }, { replace: true });
  };

  const moveToLogin = async () => {
    //----------------------로그인 페이지로 이동
    // console.log('페이지 이동');
    await navigate('/member/login');
  };

  const moveToLoginReturn = () => {
    //----------------------로그인 페이지로 이동 컴포넌트
    return <Navigate replace to="/member/login" />;
  };

  const moveToMainPrage = () => {
    window.location.href = 'https://keif.kr/';
  };

  return { loginState, isLogin, doLogin, doLogout, moveToPath, moveToLogin, moveToLoginReturn, exceptionHandler, isCookieChecked, moveToMainPrage };
};

export default useCustomLogin;
